<template>
  <div class='VisibProd'>
    <input-select
    :value="Selected"
    @update:model-value="newValue => ChangeProdEdit({ visibilidade: visibilidade.filter(v => v.name === newValue)[0].id })"
    :data="Empresa.modelo === 'Modelo 03' ? visibilidade3 : visibilidade"
    :text="Empresa.modelo === 'Modelo 03' ? 'Visibilidade do imóvel' : 'Visibilidade do produto'"
    :label="{ textAlign: 'left', marginTop: '1%', marginLeft: '5px' }"
    :input="{ width: '100%', padding: '2%', fontSize: '16px', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import InputSelect from './InputSelect'
export default {
  name: 'VisibProd',
  components: { InputSelect },
  data () {
    return {
      visibilidade: [
        { id: 1, name: 'Vitrine' },
        { id: 2, name: 'Loja e resultado de pesquisa' },
        { id: 3, name: 'Apenas na loja' },
        { id: 4, name: 'Apenas nos resultados de pesquisa' },
        { id: 5, name: 'Oculto' }
      ],
      visibilidade3: [
        { id: 1, name: 'Vitrine' },
        { id: 2, name: 'Site e resultado de pesquisa' },
        { id: 3, name: 'Apenas no site' },
        { id: 4, name: 'Apenas nos resultados de pesquisa' },
        { id: 5, name: 'Oculto' }
      ]
    }
  },
  computed: {
    ...mapGetters(['SelectedProdEdit', 'Empresa']),
    Selected () {
      return this.visibilidade.filter(v => v.id === this.SelectedProdEdit.visibilidade)[0].name
    }
  },
  methods: {
    ...mapActions(['ChangeProdEdit'])
  }
}
</script>

<style scoped>
.VisibProd {
  width: 100%;
}
</style>
